import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { ADDONS_MY_PROFILE_DISPLAY_TYPES } from '../../../Utils/Enums';

import {
  shimmerPlaceholderConfig,
  recommendedCardLoadingConfig,
  addOnsCardLoadingConfig,
  displayChangeLoadingConfig,
  requestedAddOnsCardLoadingConfig,
  titleLoadingConfig,
  subtitleLoadingConfig,
} from './AddOnsLoading.Config';
import styles from './AddOnsLoading.Styles';

function renderRecommendationShimmer() {
  return (
    <Shimmer
      config={recommendedCardLoadingConfig}
      shimmerPlaceholderConfig={shimmerPlaceholderConfig}
    />
  );
}

function renderActiveAddOnsShimmer(theme, withUsers) {
  return (
    <>
      <Shimmer config={subtitleLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
      {_map(Array(5), (_, key) => (
        <View key={key} style={[styles.addOnsCardStyle, styles.cardStyle(theme)]}>
          <Shimmer
            config={addOnsCardLoadingConfig(withUsers)}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        </View>
      ))}
    </>
  );
}

function renderExpiredAddOnsShimmer(theme, withUsers) {
  return (
    <>
      <View style={styles.expiredSubtitleStyle}>
        <Shimmer
          config={subtitleLoadingConfig}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
      </View>
      <View style={[styles.addOnsCardStyle, styles.cardStyle(theme)]}>
        <Shimmer
          config={addOnsCardLoadingConfig(withUsers)}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
      </View>
    </>
  );
}

function renderDisplayChangeButtonShimmer(withDisplayChange, displayType) {
  if (!withDisplayChange) {
    return null;
  }
  return (
    <Shimmer
      config={displayChangeLoadingConfig(displayType)}
      shimmerPlaceholderConfig={shimmerPlaceholderConfig}
    />
  );
}

function renderMyAddOnsShimmer(theme, withUsers) {
  return (
    <>
      {renderActiveAddOnsShimmer(theme, withUsers)}
      {renderExpiredAddOnsShimmer(theme, withUsers)}
    </>
  );
}

function renderRequestedAddOnsShimmer(theme) {
  return (
    <View style={styles.requestedAddOnsContainerStyle}>
      {_map(Array(2), (_, key) => (
        <View key={key} style={[styles.requestedAddOnsCardStyle, styles.cardStyle(theme)]}>
          <Shimmer
            config={requestedAddOnsCardLoadingConfig}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        </View>
      ))}
    </View>
  );
}

function AddOnsLoading({ withTray, withUsers, withDisplayChange, displayType, ...props }) {
  const theme = useTheme();
  return (
    <View style={styles.containerStyle(withTray)} {...props}>
      {renderRecommendationShimmer()}

      <View style={styles.titleContainerStyle}>
        <Shimmer config={titleLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
        {renderDisplayChangeButtonShimmer(withDisplayChange, displayType)}
      </View>

      {displayType === ADDONS_MY_PROFILE_DISPLAY_TYPES.MY_ADDONS &&
        renderMyAddOnsShimmer(theme, withUsers)}
      {displayType === ADDONS_MY_PROFILE_DISPLAY_TYPES.REQUESTS &&
        renderRequestedAddOnsShimmer(theme)}
    </View>
  );
}

AddOnsLoading.propTypes = {
  withTray: PropTypes.bool,
  withUsers: PropTypes.bool,
  withDisplayChange: PropTypes.bool,
  displayType: PropTypes.string,
};

export { renderRecommendationShimmer, renderActiveAddOnsShimmer, renderExpiredAddOnsShimmer };
export default AddOnsLoading;
